'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');
const icon = require('../Icon/icon.js');
const button_colors = require('./button.colors.js');
const button_types = require('./button.types.js');
const button_style = require('./button.style.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var linkBlue = universal_color.linkBlue;
var DEFAULT_DATA_ATTR = {
  'data-testid': 'button'
};

// Returns a simple string for qualifiying button types
var retrieveStyleButtonType = function retrieveStyleButtonType(style) {
  switch (style) {
    case button_types.ButtonStyles.DEFAULT:
      return 'default';
    case button_types.ButtonStyles.BLACK:
      return 'black';
    case button_types.ButtonStyles.GREY:
      return 'grey';
    case button_types.ButtonStyles.TICKET_LINK_GREEN:
      return 'ticketGreen';
    case button_types.ButtonStyles.MLB_TV_ORANGE:
      return 'mlbTvOrange';
    default:
      return 'linkBlue';
  }
};
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    _props$additionalProp = props.additionalProps,
    additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp,
    ariaLabel = props.ariaLabel,
    _props$ariaPressed = props.ariaPressed,
    ariaPressed = _props$ariaPressed === void 0 ? false : _props$ariaPressed,
    children = props.children,
    className = props.className,
    _props$dataAttr = props.dataAttr,
    dataAttr = _props$dataAttr === void 0 ? {} : _props$dataAttr,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$handlers = props.handlers,
    handlers = _props$handlers === void 0 ? {} : _props$handlers,
    _props$hasHover = props.hasHover,
    hasHover = _props$hasHover === void 0 ? true : _props$hasHover,
    hoverSpeed = props.hoverSpeed,
    iconHoverColor = props.iconHoverColor,
    _props$iconLeft = props.iconLeft,
    iconLeft = _props$iconLeft === void 0 ? true : _props$iconLeft,
    iconName = props.iconName,
    _props$iconProps = props.iconProps,
    iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
    iconSize = props.iconSize,
    id = props.id,
    label = props.label,
    _props$role = props.role,
    role = _props$role === void 0 ? 'button' : _props$role,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? button_types.ButtonShapes.SOLID : _props$shape,
    _props$size = props.size,
    size = _props$size === void 0 ? button_types.ButtonSizes.SMALL : _props$size,
    _props$styleName = props.styleName,
    styleName = _props$styleName === void 0 ? button_types.ButtonStyles.LINK_BLUE : _props$styleName,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? {} : _props$theme,
    _props$type = props.type,
    type = _props$type === void 0 ? button_types.ButtonTypes.BUTTON : _props$type,
    value = props.value;
  var iconColor = props.iconColor;
  var dark = theme.dark,
    teamColor1 = theme.teamColor1;
  var hSpeed;
  if (hoverSpeed !== undefined) {
    hSpeed = hoverSpeed;
  } else if (theme.hoverSpeed !== undefined) {
    hSpeed = theme.hoverSpeed;
  } else {
    hSpeed = 0.2;
  }

  // Establish the specfic version of the button
  var themeType = dark ? 'dark' : 'light';
  var hollowMode = [button_types.ButtonShapes.SOLID, button_types.ButtonShapes.PILL_SOLID].includes(shape) ? 'solid' : 'hollow';
  var buttonType = disabled ? 'disabled' : retrieveStyleButtonType(styleName);
  var borderless = shape === button_types.ButtonShapes.HOLLOW_BORDERLESS;
  var colorMap = styleName === button_types.ButtonStyles.TEAM ? button_colors.retrieveTeamColorMap(teamColor1 || linkBlue, hollowMode, themeType) : button_colors.ButtonColors[themeType][hollowMode][buttonType];

  // Retrieve the values from the color map
  var backgroundColor = colorMap.backgroundColor,
    borderColor = colorMap.borderColor,
    color = colorMap.color,
    hoverBackgroundColor = colorMap.hoverBackgroundColor,
    hoverBorderColor = colorMap.hoverBorderColor,
    hoverColor = colorMap.hoverColor;

  // Establish if only an icon was provided which will tailor the padding in the button
  var onlyIcon = !(label || children);

  // Retrieve a map of sizes required by the button (height, padding, etc.);
  var sizeStyles = button_types.buttonSizeMap[size];
  iconColor = iconColor || color;

  // Call the handler when the event is triggered
  var invokeHandler = function invokeHandler(t, e) {
    handlers[t](e, value);
  };
  var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), dataAttr);
  // Construct an object of props which will contain all aria labels, the value, handlers, etc.
  var completeButtonProps = _objectSpread(_objectSpread({
    'aria-label': ariaLabel || label,
    'aria-pressed': ariaPressed,
    className: className,
    disabled: disabled,
    ref: ref,
    role: role,
    type: type,
    value: value
  }, combinedDataAttr), additionalProps);
  Object.keys(handlers).forEach(function (key) {
    completeButtonProps[key] = function (e) {
      if (!disabled) {
        invokeHandler(key, e);
      }
    };
  });
  var iconWidth = iconSize || sizeStyles['iconSize'];
  return /*#__PURE__*/React__default.createElement(button_style.StyledButton, _extends({
    sizeStyles: sizeStyles,
    hSpeed: hSpeed,
    shape: shape,
    backgroundColor: backgroundColor,
    borderless: borderless,
    borderColor: borderColor,
    onlyIcon: onlyIcon,
    color: color,
    iconColor: iconColor,
    icon: !!iconName,
    iconLeft: iconLeft,
    disabled: disabled,
    hasHover: hasHover,
    hoverBackgroundColor: hoverBackgroundColor,
    hoverColor: hoverColor,
    hoverBorderColor: hoverBorderColor,
    iconHoverColor: iconHoverColor,
    styleName: styleName,
    id: id,
    active: active
  }, completeButtonProps), iconLeft && iconName && /*#__PURE__*/React__default.createElement(icon, _extends({
    width: iconWidth,
    name: iconName,
    fill: iconColor
  }, iconProps)), /*#__PURE__*/React__default.createElement(button_style.Label, null, label || children), !iconLeft && iconName && /*#__PURE__*/React__default.createElement(icon, _extends({
    width: iconWidth,
    name: iconName,
    fill: iconColor
  }, iconProps)));
});
const Button$1 = styled.withTheme(Button);

module.exports = Button$1;
